export default "__VITE_ASSET__BglX9n8u__"